import React from "react";

const ConditionalRender = (props: {
  children: JSX.Element;
  condition: boolean;
}): JSX.Element => {
  if (props.condition) return props.children;
  else return <></>;
};

export default ConditionalRender;
